import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"
import { ErrorLogs } from "~/pages/Admin/Ingestion/ProductImport/hooks/useVerifyProductImportMutation"

type ValidateFileOperationsResponse = {
  success: boolean
}

type ValidateFileOperationsRequest = {
  file: File | null
  clientEmail: string
}
export const useValidateOperationsFileMutation = (
  options?: UseMutationOptions<
    ValidateFileOperationsResponse,
    AxiosError<ErrorLogs>,
    ValidateFileOperationsRequest
  >
) => {
  return useMutation<
    ValidateFileOperationsResponse,
    AxiosError<ErrorLogs>,
    ValidateFileOperationsRequest
  >(
    ["validateOperationsFile"],
    async (variables) => {
      const formData = new FormData()

      if (variables.file) {
        formData.append("file", variables.file, variables.file.name)
      }
      formData.append("clientEmail", variables.clientEmail)
      const response = await httpClient.post(
        "/admin/traceability/verify-import",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      return response.data
    },
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        options?.onSuccess?.(data, variables, context)
      },
    }
  )
}
